import React from 'react'
import PropTypes from 'prop-types'
import i18n from 'i18next'

import ErrorModal from '#components/m/ErrorModal'

function TopLevelErrorModal({showError, onOkClicked, errorMessage, error, appInsights}) {
  const expectedErrorWithMessage = error?.isExpectedError && errorMessage

  const text = expectedErrorWithMessage ? errorMessage : `${i18n.t('misc_unknown_error')} ${i18n.t('please_try_again')}`
  const headline = expectedErrorWithMessage ? i18n.t('misc_error_title') : i18n.t('ups')
  return (
    <ErrorModal
      key="subcritical-error-modal"
      headline={headline}
      text={text}
      showModal={showError}
      buttonText={i18n.t('okay')}
      onButtonClick={onOkClicked}
      error={error}
      appInsights={appInsights}
    />
  )
}

TopLevelErrorModal.propTypes = {
  showError: PropTypes.bool,
  onOkClicked: PropTypes.func,
  errorMessage: PropTypes.string,
  error: PropTypes.object,
  appInsights: PropTypes.any,
}

export default TopLevelErrorModal
